import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../features/products/productSlice";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import Container from "./Container";
import loader from "../images/loader/loader1.jpg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PiEngineFill } from "react-icons/pi";
import { FaCar } from "react-icons/fa";
import { FaRoad } from "react-icons/fa";
import { RiSteering2Fill } from "react-icons/ri";


function countWords(text) {
  return text.split(/\s+/).filter(word => word !== "").length;
}

const RelatedCarFinancing = () => {
  const productState = useSelector((state) => state.product.product);
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const isTitleTooLong = productState?.some(item => countWords(item?.title) > 10);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllProducts());
  }, [dispatch]);

  const handleProductView = (productSlug) => {
    navigate(`/vehicle/${productSlug}`);
  };

  return (
    <Container class1="featured-wrapper home-wrapper-2">
      <div className="related__loan-header">
<div className={`col-12 bg-white ${isDesktop ? "mt-5" : "mt-3"}`}>
    <h2>Other Affordable Payment Plan Deals</h2>
    <p className="section-subtitle">
      Check out financing options available for these vehicles and find a plan that fits your budget.
    </p>
</div>

      </div>
      <div className={`featured-collection ${isDesktop ? "featured" : ""}`}>
        {productState &&
          productState
            .filter((item) => item.tags === "New Arrivals")
            .slice(0, 8)
            .map((item, index) => (
              <div key={index} className={"col-3 px-0"}>
                <div
                  className="product-card position-relative"
                  onClick={() => handleProductView(item.slug)}
                >
                  <div className="product-image new-arrivals-img-container">
                    <LazyLoadImage
                      alt={item?.title}
                      title={item?.title}
                      effect="blur"
                      src={item?.images[0]?.url || loader}
                      placeholderSrc={loader}
                      width="100%"
                      height={isDesktop ? 250 : "100%"}
                      loading="lazy"
                      className="img-fluid mx-auto img-el"
                    />
                  </div>
            <div className="product-details">
              <h5 className="product-title ellipsis" >
                {item?.title}
              </h5>
            <div className="features">
              <span className="feature-item">
                <RiSteering2Fill className="feature-icon"/> 
                <span className="feature-text">{item?.transmission}</span>
              </span>

              <span className="feature-item">
                <PiEngineFill className="feature-icon"/> 
                <span className="feature-text">{item?.engineSize?.title}</span>
              </span>

              <span className="feature-item">
                <FaCar className="feature-icon"/> 
                <span className="feature-text">{item?.yom}</span>
              </span>

              <span className="feature-item">
                <FaRoad className="feature-icon"/> 
                <span className="feature-text">{item?.fuelType}</span>
              </span>
            </div>

                    <div className="price-wrapper">
                      <p className="nw-price">KES {item?.price.toLocaleString()}</p>
                      <button className="view-button"><span>Details</span></button>
                    </div>

             
            </div>
                </div>
              </div>
            ))}
      </div>
    </Container>
  );
};

export default RelatedCarFinancing;
